import React, { useState, useEffect } from "react";
// import {
//   CardCvcElement,
//   CardExpiryElement,
//   CardNumberElement,
//   useElements,
//   useStripe,
//   // CardElement
// } from "@stripe/react-stripe-js";
import Calendar from "react-calendar";
// import { useMutation } from "react-query";
import moment from "moment";
import "react-calendar/dist/Calendar.css";
import LoadingComponent from "../Components/LoadingComponent";
import { getTimeSlots } from "../api";

// import { CreateConsultation, url } from "../api/index";
// import Swal from "sweetalert2";

import Header from "./Header";
import Logo from "./Logo";
import "./Shoulde.css";
// import axios from "axios";
// import { useHistory } from "react-router-dom";

const Scheduleinfo = ({
  setStep,
  setConsultationType,
  onCreateConsultation,
  consultationType,
  setSlotId,
  setDoctorId,
  setStartTime,
  setEndTime,
  slotId,
  price,
  // temp,
  // amount
  // createConsultation,
}) => {
  const [selectedDate, onChange] = useState(new Date());
  const [timeList, setTimeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaynetLoading] = useState(true);
  // const [consultationId, setConsultationId] = useState();

  // const token = localStorage.getItem("token");
  // const stripe = useStripe();
  // const elements = useElements();
  // const history = useHistory();

  console.log(paymentLoading, "30");
  // console.log(consultationType, slotId);
  const fetchTime = async (value) => {
    setLoading(true);
    console.log(moment(value).local().format("YYYY-MM-DD"));
    const response = await getTimeSlots(
      moment(value).local().format("YYYY-MM-DD")
    );
    console.log(response.data, "timeslots");
    onChange(value || selectedDate);

    let now = new Date();
    let filteredTimeSlots = response.data.filter((el) => {
      let d = new Date(el.start);
      return now.getTime() < d.getTime() && el.isReserved !== true;
    });
    setLoading(false);
    setTimeList(filteredTimeSlots);
  };

  useEffect(async () => {
    fetchTime();
    // submitHandler()
  }, []);

  console.log(slotId);

  const SelectSlot = (slotId, doctorId, start, end) => {
    setSlotId(slotId);
    setDoctorId(doctorId);
    setStartTime(start);
    setEndTime(end);
  };

  const tileClassName = ({ date, view }) => {
    if (
      view === "month" &&
      date.toDateString() === selectedDate.toDateString()
    ) {
      return "selected-day";
    }
    return null;
  };

  //-----------------------------------------------------------//

  // const { mutate } = useMutation(CreateConsultation, {
  //   onSuccess: (data) => {
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "success",
  //       title: "Consultation Created Successfully!!!",
  //       showConfirmButton: true,
  //       timer: 2000,
  //     }).then(() => {
  //       setLoading(false);
  //       history.push("/dashboard/allconsultations");
  //     });
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "error",
  //       title: "Consultation Created Failed!!!",
  //       text: error?.response?.data?.message,
  //       showConfirmButton: true,
  //       timer: 2000,
  //     });
  //     setLoading(false);
  //   },
  // });

  // const submitHandler = async () => {
  //   // let res;
  //   try {
  //     let price = null;
  //     consultationType == "phone_call"
  //       ? (price = amount?.audioCall)
  //       : consultationType == "video_call"
  //       ? (price = amount?.videoCall)
  //       : (price = amount?.writtenReportAnalysis);
  //     let res;
  //     if (consultationType == "written_report_analysis") {
  //       res = await axios.patch(
  //         `${url}/consultations/update-written-report`,
  //         { amount: price, consultationId: temp?._id, status: true },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //     } else {
  //       res = await axios.put(
  //         `${url}/consultations/updateConsultation`,
  //         { amount: price, consultationId: temp?.data?._id },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //     }
  //     if ((res?.status == "201", "200")) {
  //       // console.log("res", res?.response);

  //       // paymentprice
  //       try {
  //         let price = null;
  //         consultationType == "phone_call"
  //           ? (price = Math.round(amount?.audioCall * 100))
  //           : consultationType == "video_call"
  //           ? (price = Math.round(amount?.videoCall * 100))
  //           : (price = Math.round(amount?.writtenReportAnalysis * 100));
  //         // setConsultationPrice(price);
  //         // console.log(price);
  //         setLoading(true);
  //         res = await axios.post(
  //           `${url}/payment/pay`,
  //           { amount: price },
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );

  //         const clientSecret = res.data.client_secret;

  //         if (!stripe || !elements) {
  //           return;
  //         }

  //         const result = await stripe.confirmCardPayment(clientSecret, {
  //           payment_method: {
  //             // card: elements.getElement(CardElement),
  //             card: {
  //               token: "tok_visa",
  //             },
  //           },
  //         });
  //         if (result.error) {
  //           setLoading(false);
  //           Swal.fire({
  //             position: "top-end",
  //             icon: "error",
  //             title: "Payment Failed!!!",
  //             text: result?.error?.response?.data?.message,
  //             showConfirmButton: true,
  //             timer: 2000,
  //           });
  //         } else {
  //           // The payment is processed or not
  //           if (result.paymentIntent.status === "succeeded") {
  //             try {
  //               // mutate(formdata);
  //               console.log("payment succeeded");
  //               Swal.fire({
  //                 position: "top-end",
  //                 icon: "success",
  //                 title:
  //                   consultationType == "written_report_analysis"
  //                     ? "Your Report is under review"
  //                     : "Consultation Created Successfully!!!",
  //                 showConfirmButton: true,
  //                 timer: 2000,
  //               }).then(() => {
  //                 setLoading(false);
  //                 history.push("/dashboard/allconsultations");
  //               });
  //             } catch (error) {
  //               Swal.fire({
  //                 position: "top-end",
  //                 icon: "error",
  //                 title: "Consultation Created Failed!!!",
  //                 text: error?.response?.data?.message,
  //                 showConfirmButton: true,
  //                 timer: 2000,
  //               });
  //               setLoading(false);
  //             }
  //           } else {
  //             setLoading(false);
  //             Swal.fire({
  //               position: "top-end",
  //               icon: "error",
  //               title: "Payment Failed!!!",
  //               text: "There is some error while payment processing",
  //               showConfirmButton: true,
  //               timer: 2000,
  //             });
  //           }
  //         }
  //       } catch (error) {
  //         let res;
  //         if (consultationType == "written_report_analysis") {
  //           res = await axios.patch(
  //             `${url}/consultations/update-written-report`,
  //             { consultationId, status: false },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //         } else {
  //           res = await axios.patch(
  //             `${url}/consultations/delete-consultation`,
  //             { consultationId },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //         }

  //         if ((res?.status == "201", "200")) {
  //           console.log("res", res?.response);
  //           setLoading(false);
  //         } else {
  //           console.log(error);
  //           setLoading(false);
  //           Swal.fire({
  //             position: "top-end",
  //             icon: "error",
  //             title: "Consultaion Failed!!!",
  //             text: error?.response?.data?.message,
  //             showConfirmButton: true,
  //             timer: 2000,
  //           });
  //         }
  //       }
  //     } else {
  //       console.log("status not updated, payment failed", res.response);
  //       setLoading(false);
  //     }
  //   } catch (e) {
  //     console.log("status not update");
  //     setLoading(false);
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "error",
  //       title: "Consultaion Failed!!!",
  //       text: e?.response?.data?.message,
  //       showConfirmButton: true,
  //       timer: 2000,
  //     });
  //   }
  // };

  //----------------------------------------------------------//

  const renderTimeList = () => {
    return (
      <div className="doctor-list">
        {timeList.map((list) => {
          return (
            <>
              {!list?.isReserved && (
                <button
                  key={list}
                  onClick={() =>
                    SelectSlot(
                      list._id,
                      list.doctorId,
                      new Date(list.start).toISOString(),
                      new Date(list.end).toISOString()
                    )
                  }
                  class={`selecttime1 ${
                    slotId === list._id ? "active-select" : ""
                  }`}
                >
                  {`${new Date(list.start).toLocaleTimeString("en", {
                    timeStyle: "short",
                    hour12: true,
                  })}-${new Date(list.end).toLocaleTimeString("en", {
                    timeStyle: "short",
                    hour12: true,
                  })}`}
                </button>
              )}
            </>
          );
        })}
      </div>
    );
  };

  console.log(price, "Price");
  console.log(loading);

  return (
    <div className="patientinfo">
      <Logo />
      <div className="card wizard-card">
        <div className="centre_content">
          <Header active={2} />
        </div>
        <div className="main">
          <div className="wizard-top-bar">
            <h3>Please Select Consultation Type</h3>
          </div>
          <div className="right">
            <button
              className="llll"
              style={{
                backgroundColor: "transparent",
                color: "#000",
                fontSize: "20px",
                fontWeight: "400",
                fontFamily: "Poppins",
              }}
              // onClick={submitHandler}
            >
              Price{" "}
              <span style={{ color: "#02C4B7", fontWeight: "600" }}>
                ${price}
              </span>
            </button>
          </div>
        </div>
        <div className="flexdivv">
          <div className="contactsec">
            <div className="d-flex md:flex-row flex-col ">
              <div
                style={{ marginLeft: "20px", display: "flex" }}
                className="form-check"
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  defaultValue="option1"
                  checked={consultationType === "written_report_analysis"}
                  onClick={() => {
                    setConsultationType("written_report_analysis");
                  }}
                />
                <label
                  style={{ marginLeft: "10px" }}
                  className="form-check-label"
                  htmlFor="exampleRadios1"
                >
                  Written Report Analysis
                </label>
              </div>
              <div className="form-check" style={{ marginLeft: "20px" }}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  checked={consultationType === "phone_call"}
                  onClick={() => {
                    setConsultationType("phone_call");
                  }}
                />
                <label className="form-check-label" htmlFor="exampleRadios2">
                  Phone Call
                </label>
              </div>
              <div className="form-check" style={{ marginLeft: "20px" }}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios3"
                  defaultValue="option2"
                  checked={consultationType === "video_call"}
                  onClick={() => {
                    setConsultationType("video_call");
                  }}
                />
                <label className="form-check-label" htmlFor="exampleRadios3">
                  Video Call
                </label>
              </div>
            </div>

            {consultationType !== "written_report_analysis" ? (
              !loading ? (
                timeList.length === 0 ? (
                  <h4 style={{ marginTop: "100px", textAlign: "center" }}>
                    No Time Slot is available
                  </h4>
                ) : (
                  <div className="selectchecktime">{renderTimeList()}</div>
                )
              ) : (
                <div style={{ height: "100px" }}>
                  <LoadingComponent />
                </div>
              )
            ) : null}
          </div>
          {consultationType !== "written_report_analysis" ? (
            <div className="date-select">
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  fontFamily: "Poppins",
                  paddingBottom: "10px",
                }}
              >
                Please Select a Date:
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    paddingBottom: "10px",
                    color: "#03ab9f",
                  }}
                >
                  Are slots are according to MST Timezone.
                </p>
              </div>
              <Calendar
                minDate={new Date()}
                onChange={fetchTime}
                value={selectedDate}
                className="cal"
                tileClassName={tileClassName}
              />
            </div>
          ) : null}
        </div>

        <div
          className="wizard-footer height-wizard"
          style={{ paddingInline: "7px" }}
        >
          <div className="pull_left">
            <button
              className="llll"
              style={{ backgroundColor: "#999" }}
              onClick={() => {
                setStep(1);
              }}
            >
              PREVIOUS
            </button>
          </div>
          <div className="pull_right">
            <button
              className="KKK"
              style={{
                width: "150px",
                fontSize: "12px",
                position: "relative",
                height: "32px",
              }}
              // onClick={handleShow}
              disabled={
                consultationType !== "written_report_analysis" && slotId === ""
                  ? true
                  : false
              }
              // onClick={() => onCreateConsultation()}
              onClick={(e) => {
                console.log("slotId", slotId);

                onCreateConsultation(e);
                setPaynetLoading(false);
                setTimeout(() => {
                  setPaynetLoading(true);
                }, 3000);
              }}
            >
              {paymentLoading ? (
                "PROCEED TO PAYMENT"
              ) : (
                <LoadingComponent
                  mainLoaderHeight="30px"
                  loaderheight="20px"
                  class="centerLoader"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {/* 
      <Payment show={show} handleClose={handleClose} /> */}
    </div>
  );
};

export default Scheduleinfo;
